import { render, staticRenderFns } from "./LaboratoriesModule.vue?vue&type=template&id=7c09b8b2&scoped=true&"
import script from "./LaboratoriesModule.vue?vue&type=script&lang=js&"
export * from "./LaboratoriesModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c09b8b2",
  null
  
)

export default component.exports